import { useSelector } from "react-redux"
import { MemorizingWrapper, CircleTextWrapper, Circle, Line, TextWrapper, CircleHeading, CircleText } from "./MemorizingStyle"

import { MemorizeData } from './01_data/MemorizeData'
import { vocabulary } from "../../../i18n/05_vocabulary"

const Memorizing = () => {
  const lang = useSelector(state => state.lang.lang)
  const t = vocabulary[lang]

  return (
    <MemorizingWrapper>
      {t.memorizingData.map((value, index) => (
        <CircleTextWrapper key={index}>
        <Circle>{value.circleNumber}</Circle>
        <TextWrapper>
          <CircleHeading>{value.circleHeading}</CircleHeading>
          <CircleText>{value.circleText}</CircleText>
        </TextWrapper>
        </CircleTextWrapper>
      ))}
      <Line />
    </MemorizingWrapper>
  )
}

export default Memorizing